import axios from '@/utils/axios'
import { AxiosPromise } from 'axios'

/**
 * Profile request
 *
 * @param params
 */
export const index = (params = {}): AxiosPromise => {
  return axios.get('/dramas', { params })
}

/**
 * Update attribute
 *
 * @param id
 * @param params
 */
export const updateAttribute = (id: number, params = {}): AxiosPromise => {
  return axios.put(`/dramas/${id}/attribute`, params)
}

/**
 * @param id
 */
export const destroy = (id: number): AxiosPromise => {
  return axios.delete(`/dramas/${id}`)
}
